export default __webpack_public_path__ + "static/media/add.55418dd1.svg";